import { stringifyUrl } from '@app/utils/stringifyUrl'

/**
 * A v2 endpoint with its query, relative — the dispatcher owns the base url.
 *
 * It goes through `stringifyUrl` against a placeholder host so a query serialises byte-identically
 * to what the builder's `api.path()` produced (`key[]` for arrays, `URL`'s own escaping on top of
 * qs). The recorded http fixtures match on the full url, so any drift here silently invalidates
 * them.
 */
export const v2Path = (path: string, query?: { [key: string]: any }) =>
  stringifyUrl({ url: `${PLACEHOLDER_BASE}${path}`, query }).slice(PLACEHOLDER_BASE.length)

const PLACEHOLDER_BASE = 'http://v2.invalid'
